import { GQLResponseError, GQLResponseServerError } from '@change-corgi/core/gql';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { PsfPromoteOrShareRecruiterQuery, PsfPromoteOrShareRecruiterQueryVariables } from './recruiter.graphql';
import { PsfPromoteOrShareRecruiter } from './recruiter.graphql';

export async function getRecruiter(
	{ gql }: UtilityContext,
	recruiterId: string,
): Promise<NonNullable<PsfPromoteOrShareRecruiterQuery['recruiter']> | undefined> {
	try {
		const { data } = await gql.fetch<PsfPromoteOrShareRecruiterQuery, PsfPromoteOrShareRecruiterQueryVariables>({
			query: PsfPromoteOrShareRecruiter,
			variables: { recruiterId },
			rejectOnError: true,
		});
		return data.recruiter ?? undefined;
	} catch (error) {
		// The recruiter lookup can fail (e.g. invalid/stale recruiterId); the caller treats a
		// missing/errored result as "no recruiter". Only a GQL-level error confined to `recruiter`
		// (the only field this query requests) is tolerated here — a transport/server failure
		// (GQLResponseServerError, incl. PerimeterX challenges) still propagates and fails the page
		// load, same as today: rejectOnError: false never covered transport failures either, so this
		// preserves existing behavior rather than widening it.
		if (error instanceof GQLResponseError && !(error instanceof GQLResponseServerError)) {
			return undefined;
		}
		throw error;
	}
}
